export default "__VITE_ASSET__CK$2ZW7i__"